
import { mapState } from 'vuex'
import eventBus from '~/event-bus'
// const sound = new Audio(require('@/assets/sounds/when-604.ogg'))

export default {
  props: ['notifyUrl'],
  data: () => ({
    menu: false,
    countNew: null,
    notifications: null,
    loading: false,
    size: 10
  }),
  computed: {
    ...mapState('session', ['user'])
  },
  watch: {
    menu (value) {
      if (value) {
        this.fetchNotifications()
      } else {
        this.countNotifications()
        this.notifications = null
        this.size = 10
      }
    }
  },
  mounted () {
    this.countNotifications()
    // always subscribe to notifications from notify
    if (this.user) {
      const channel = `user:${this.user.id}:notifications`
      eventBus.$emit('subscribe-notify', channel)
      eventBus.$on(channel, notification => {
        // sound.play()
        if (this.notifications) {
          notification.new = true
          this.notifications.unshift(notification)
          // TODO: replace this with a endpoint simply to reset pointer
          this.$axios.$get(`${this.notifyUrl}/api/v1/notifications`, { params: { size: 1, count: false } })
        }

        if (this.countNew !== null) {
          this.countNew += 1
        }
      })
    }
  },
  methods: {
    async countNotifications () {
      const res = await this.$axios.$get(`${this.notifyUrl}/api/v1/notifications`, { params: { size: 0, count: false } })
      this.countNew = res.countNew
    },
    async fetchNotifications () {
      this.loading = true
      const res = await this.$axios.$get(`${this.notifyUrl}/api/v1/notifications`, { params: { size: this.size, count: false } })
      this.countNew = res.countNew
      this.notifications = res.results
      this.loading = false
    }
  }
}
